import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiceLayer } from '../../../services/serviceLayer';
import { DAO, emptyModal, modalValues } from '../../../modal/DAO';
import { MessageService } from 'primeng/api';
import { NgForm } from '@angular/forms';
import { Constants } from 'src/app/modal/ProjConstants.models';
import { map } from 'rxjs/operators';
import _ from 'lodash';
declare var require: any;
import { CommonService } from 'src/app/services/commonService';
import { ResponseContainer } from 'src/app/modal/questionnaire.models';
import { HttpResults, workInProgress } from 'src/app/modal/routing.models';
import { DateService } from 'src/app/services/date.service';

@Component({
  selector: 'app-dot',
  templateUrl: './dot.component.html'
})
export class DotComponent implements OnInit {
  @ViewChild('dotForm') dotForm: NgForm;
  constructor(public serviceLayer: ServiceLayer,
    public dao: DAO,
    public dateService : DateService,
    private messageService: MessageService, private commonService: CommonService) { }

  public IsSubmit: boolean = false;
  public IsSubmitFleet: boolean = false;
  public PrimaryDOTMsg: string = '';
  public fleetSizeOptions = Constants.FleetSizeOptions;
  public retailerSubCode: string = null;
  public dotNumber: string = "";
  public isShowFleet: boolean = false;
  public powerUnitsSize: string = "1";
  public dotEffectiveDate: emptyModal = new emptyModal();
  public dotExpirationDate: emptyModal = new emptyModal();
  public mindotEffectiveDate: Date = new Date();
  public maxdotEffectiveDate: Date = new Date();
  private isDOTExistsCheckClearance: boolean = false;
  public isIncumbentAgent: emptyModal = new emptyModal();
  public agencyCode: string = "";
  public carrierEffectiveDate: string = "";
  public referenceNumber: string = "";
  public underwriterUserName: string = "";

  // ========= Page Load =====================
  ngOnInit(): void {
    this.mindotEffectiveDate.setDate(this.mindotEffectiveDate.getDate() + 5);
    this.maxdotEffectiveDate.setDate(this.maxdotEffectiveDate.getDate() + 60);
  }
  // ========= Submit the DOT =====================
  public SubmitDOT = async (form: NgForm): Promise<void> => {
    this.IsSubmit = true;
    this.isShowFleet = false;
    this.powerUnitsSize = '';
    this.referenceNumber = '';
    if (form.invalid) {
      return;
    }
    this.dotNumber = this.dotNumber.trim();
    if (!!this.dotNumber) {
      if (this.dotNumber.length > 8) {
        this.messageService.add({ key: 'RequiredMsg', severity: 'error', summary: 'DOT #', detail: 'DOT number cannot be greater than 8 numbers.' });
      } else {
        let isExistsDOT: HttpResults = await this.checkIsExistsDOT(parseInt(this.dotNumber));
        if (isExistsDOT.isSuccess == false) {
          if (isExistsDOT.responseText == 'Validate') {
            this.messageService.add({ key: 'RequiredMsg', severity: 'error', summary: 'DOT #', detail: 'DOT number cannot be greater than 8 numbers.' });
          } else {
            if (isExistsDOT.responseText != 'DOT Exists') {
              this.messageService.add({ key: 'RequiredMsg', severity: 'error', summary: 'DOT #', detail: isExistsDOT.responseText });
            } else {
              this.messageService.add({ key: 'RequiredMsg', severity: 'error', summary: 'DOT #', detail: 'This DOT is already ' + isExistsDOT.responseText + '. Please create a new submission.' });
              setTimeout(() => {
                window.location.href = '/home'
              }, 3000);
            }

          }

        }
        else if (isExistsDOT.responseText != "DOT Exists" && !this.isDOTExistsCheckClearance) {
          await this.GenerateReferenceNumberAndShowMore();
          if (this.dao.DOTLookupStatusMsg != null && this.dao.DOTLookupStatusMsg.length > 0) {
            this.isShowFleet = false;
            document.body.style.pointerEvents = "none";
            this.messageService.add({ key: 'responseMsg', sticky: true, severity: 'warn', summary: 'DOT #', data: this.dao.DOTLookupStatusMsg[0] });
          }
        }
      }
    }
    else {
      this.messageService.add({ key: 'RequiredMsg', severity: 'error', summary: 'DOT #', detail: Constants.PLS_UPDATE_FIELDS_IN_RED });
    }
  }

   //To update the policy expiration date based on the selected policy effective date.
   public updatedotExpirationDate() : void {
    this.dotExpirationDate.answer = this.dotEffectiveDate?.answer ? new Date(new Date(this.dotEffectiveDate?.answer).setFullYear(new Date(this.dotEffectiveDate?.answer).getFullYear() + 1)) : null;
  }

  public onBeginningEffectiveDateChange(event: any) {
    let parsedDate: Date | null = null;

    // Handle different event types
    if (event instanceof Date) {
      // onSelect case
      parsedDate = event;
    } else if (event?.target?.value) {
      // onBlur case (string value)
      parsedDate = this.parseDateFromEvent(event);
    }

    // if event.target.value looks like '01/01/yyyy', set the effective date to null
    if (!parsedDate) {
      this.dotEffectiveDate.answer = null;
      this.dotExpirationDate.answer = null;
      return;
    }

    // if event.target.value is within max min range, bind it to the ngModel value
    const normalizedDate = this.dateService.getCorrectDate(parsedDate);
    if (normalizedDate.getTime() >= this.mindotEffectiveDate.getTime() && normalizedDate.getTime() <= this.maxdotEffectiveDate.getTime()) {
      this.dotEffectiveDate.answer = normalizedDate;
      this.updatedotExpirationDate();
      return;
    }
  }

  private parseDateFromEvent(event: any): Date | null {
    const value = event?.target?.value;
    if (!value) {
      return null;
    }

    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  // ========= Continue DOT =====================
  public continueDOT(): void {
    if (this.dotForm.valid) {
      if (this.powerUnitsSize != '10+') {
        let dotNumberValue = parseInt(this.dotNumber)
        if (!isNaN(dotNumberValue) && !!this.dao.SubmissionList && this.dao.SubmissionList.length > 0 
                && this.dao.SubmissionList.filter(c => c.dotNumber == dotNumberValue && c.status =="Incomplete").length > 0) {
          //Very unlike to hit here. If so, check again from DB again and redirect to incomplete submission
          this.checkIsExistsDOT(parseInt(this.dotNumber)).then(
            (resp: HttpResults) =>
            {
                if (resp.isSuccess && resp.responseText != "DOT Exists")
                {
                    this.ContinueDot();
                }
                else
                {
                    this.messageService.add({ key: 'RequiredMsg', severity: 'error', summary: 'DOT #', detail: 'Error: ' + resp.responseText + ". Please contact BSB Customer Service. "});
                }
            });           
        }
        else {
          this.ContinueDot();
        }
      }
      else {
        window.location.href = "https://www.berkleyprimetrans.com/agents/submit-your-business/";
      }
    }
    else {
      this.messageService.add({ key: 'RequiredMsg', severity: 'error', summary: 'DOT #', detail: Constants.PLS_UPDATE_FIELDS_IN_RED });
    }
  }

  public async ContinueDot(): Promise<void> {
    this.dao.DOTList = await this.serviceLayer.getSubmissionModel();
    this.dao.DOTList.dotQsnr.addOrUpdateQuestion("accountDot", this.dotNumber);
    this.dao.DOTList.dotQsnr.addOrUpdateQuestion("fleetSize", this.powerUnitsSize);
    this.dao.DOTList.dotQsnr.addOrUpdateQuestion("retailerSubCode", this.retailerSubCode);
    this.dao.DOTList.dotQsnr.addOrUpdateQuestion("agencyCode", this.agencyCode);
    this.dao.DOTList.dotQsnr.addOrUpdateQuestion("number", this.referenceNumber);
    this.dao.DOTList.dotQsnr.addOrUpdateQuestion("dotEffectiveDate", this.dateService.getDateString(this.dotEffectiveDate.answer));
    this.dao.DOTList.dotQsnr.addOrUpdateQuestion("dotExpirationDate", this.dateService.getDateString(this.dotExpirationDate.answer));
    this.dao.DOTList.dotQsnr.addOrUpdateQuestion("isIncumbentAgent", this.isIncumbentAgent.answer);
    this.dao.DOTList.dotQsnr.addOrUpdateQuestion("underwriterUserName", this.underwriterUserName);

    await this.checkSubmissionDOT();
    if (this.dao.DOTLookupStatusMsg != null && this.dao.DOTLookupStatusMsg.length > 0) {
      document.body.style.pointerEvents = "none";
      this.messageService.add({ key: 'cab_invalid', sticky: true, severity: 'warn', data: this.dao.DOTLookupStatusMsg });
    }
    else if (this.dao.isDOTValid) {
      this.dao.PolicyTemplate = 'AccountInfo'
    }
    this.serviceLayer.setActiveMenu();
  }

  public resetPrimaryDOT(type: string): void {
    this.messageService.clear(type);
    document.body.style.pointerEvents = "visible";
    this.isShowFleet = false;
    this.IsSubmit = false;
    this.IsSubmitFleet = false;
    this.PrimaryDOTMsg = '';
    this.dotNumber = "";
    this.powerUnitsSize = '';
  }

  // ========= Cancel =====================
  public cancel(): void {
    this.messageService.clear();
    this.messageService.add({ key: 'Success', severity: 'success', summary: 'DOT #', detail: 'Thank you for considering Berkley Small Business Solutions for your small trucking needs. Looking forward to working with you on the next submission!' });
    setTimeout(() => {
      window.location.href = '/home'
    }, 1000);
    document.body.style.pointerEvents = "visible";
    this.isShowFleet = false;
    this.powerUnitsSize = '';
  }
  public submit(): void {
    this.isShowFleet = true;
    this.messageService.clear();
    document.body.style.pointerEvents = "visible";
  }
  // ========= Numbers only =====================
  public numbersOnly(e) {
    return this.serviceLayer.numbersOnly(e, 'dot');
  }
  keyPress(event) {
    var charCode = event.keyCode;
    // Charcodes -> Uppercase Alphabets(65-90), Lowercase Alphabets(97-122), Numerics(48-57), WhiteSpaces(32), Hyphen(45), Pound(35)
    return (charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode > 47 && charCode < 58) || (charCode == 35 || charCode == 45 || charCode == 32)
  }

  // ====== Generate Reference number and get Underwriter username =======
  public async GenerateReferenceNumberAndShowMore(): Promise<void> {
    let response : { agencyCode: string, referenceNumber: string, cabStatusCode: number, underwriterUserName: string, carrierEffectiveDate: string } = await this.createReferenceNo(this.retailerSubCode);
    // in the API, we called CAB service and assigned the Http status code in the 'value' property
    if (response.cabStatusCode == 404) {
      document.body.style.pointerEvents = "none";
      this.messageService.add({ key: 'cab_invalid', sticky: true, severity: 'warn', summary: 'DOT #', data: 'The DOT you entered was not found. Please validate the DOT number and enter again.' });
      return;
    }
    else if (response.cabStatusCode >= 404) {
      document.body.style.pointerEvents = "none";
      this.messageService.add({ key: 'cab_invalid', sticky: true, severity: 'warn', summary: 'DOT #', data: 'Portal is experiencing intermittent system outage, please try after some time' });
      return;
    }

    if (!!response.referenceNumber != null) {
      this.referenceNumber = response.referenceNumber;
      this.agencyCode = response.agencyCode;
      this.underwriterUserName = response.underwriterUserName;
      this.carrierEffectiveDate = response.carrierEffectiveDate;
      this.isShowFleet = true;
    }

  }

  private cleanUserName(name: string): string {
    return name.replace(/\t/g, '') 
      .replace(/[^a-zA-Z\s'-]/g, '') 
      .replace(/\s+/g, ' ') 
      .trim();
  }
  public async createReferenceNo(retailerSubCode: string): Promise<{ agencyCode: string, referenceNumber: string, cabStatusCode: number, underwriterUserName: string, carrierEffectiveDate: string }> {
    if (retailerSubCode === "") {
      retailerSubCode = null;  
    }
    this.dao.auth0User1.given_name = this.cleanUserName(this.dao.auth0User1.given_name);
    this.dao.auth0User1.family_name = this.cleanUserName(this.dao.auth0User1.family_name);
    let agentName = this.dao.auth0User1.given_name + ' ' + this.dao.auth0User1.family_name;
    let payload = { "urlData": [], "payloadData":  {
              DotNumber: this.dotNumber,
              Email: this.dao.userMail,
              Company: this.dao.userCompany,
              RetailerSubCode: retailerSubCode,
              AgentName: agentName
    } };
    const result: unknown = await this.commonService.post('dot', 'getReferenceNo', payload).toPromise();
    return result as { agencyCode: string, referenceNumber: string, cabStatusCode: number, underwriterUserName: string, carrierEffectiveDate: string };
  }

  // ========= Get DOT Exists =====================
  public async checkIsExistsDOT(accountDot: number): Promise<HttpResults | null> {
    let payload = { "urlData": [accountDot, this.dao.userMail, this.dao.userAgencyCode] }
    let result = null;
    await this.IsExistsDOT(payload).then(
        async (data: HttpResults) => {
            this.isDOTExistsCheckClearance = false;
            if (!!data) {
                if (data.responseText == "DOT Exists") {
                    if (!! data?.userData) {
                        let myIncompleteWip: workInProgress = data.userData as workInProgress;
                        if(!!myIncompleteWip.referenceNumber && (myIncompleteWip.status == "Incomplete" || myIncompleteWip.status == "Indication"))
                        {
                            this.dao.ExistsDOTSubmitData = {};
                            this.dao.ExistsDOTSubmitData.data = myIncompleteWip;
                            await this.serviceLayer.bindDatafromWIP(this.dao.ExistsDOTSubmitData);
                            this.isDOTExistsCheckClearance = true;
                        }
                    }
                }
            }            
            result = data;
        }
    )
    .catch(err => this.popupGeneralError(err));
    return result;
  }

  public async checkSubmissionDOT() {
    if (!this.dao.DOTList?.questionnaire) {
      return;
    }

    let payload = {
      urlData: [this.dao.userCompany, this.dao.userMail, 'AccountInfo', 'dot'],
      payloadData: this.dao.DOTList
    };

    try {
      let detail: any = await this.commonService
        .post('DOT', 'CheckSubmissionAndPostDOT', payload)
        .pipe(
          map((resp: ResponseContainer | any) => {
            if (resp?.isStatusReceived) {
              this.serviceLayer.appComponent.duplicatePopup?.();
              return null;
            }

            let container = ResponseContainer.fromJSON(resp);
            this.dao.DOTList = container;
            this.dao.finalSubmitPage = container.finalSubmitPage;

            return container;
          })
        )
        .toPromise();

      this.serviceLayer.dotSubmissionDetails.next(detail);

      if (detail) {
        this.dao.navigatePage = this.dao.finalSubmitPage;
        await this.serviceLayer.checkEvaluatequestionaire('LookUpDot');
      }

      return detail;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  // ====== Get DOT Exists ====
  public async IsExistsDOT(payload): Promise<HttpResults | null> {
    var result: any = await this.commonService.get('dot', 'checkIsExistsDOT', payload).toPromise();
    return result as HttpResults;
  }

  private popupGeneralError(err)
  {
    this.messageService.add({ key: 'declinePopup', sticky: true, severity: 'error', summary: 'Your submission could not be transmitted at this time.  Please try again later or contact Berkley Small Business Solutions at help@berkleysmallbusiness.com for additional support.' });
    console.error(err);
  }
}
